import { render, staticRenderFns } from "./journey-view-email-popover.vue?vue&type=template&id=22d0898d&scoped=true"
import script from "./journey-view-email-popover.vue?vue&type=script&lang=js"
export * from "./journey-view-email-popover.vue?vue&type=script&lang=js"
import style0 from "./journey-view-email-popover.vue?vue&type=style&index=0&id=22d0898d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d0898d",
  null
  
)

export default component.exports